import React, { useState } from "react";
import AuthLayout from "./AuthLayout";
import { Link, useNavigate } from "react-router-dom";
import { authApi } from "../../api/client";
import { getApiErrorMessage } from "../../api/http";
import { clearResetToken, getResetToken } from "../../utils/session";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    const token = getResetToken();
    if (!token) {
      setError("Reset token missing. Please verify code again.");
      return;
    }

    setLoading(true);
    try {
      await authApi.resetPassword({ token, newPassword: password });
      clearResetToken();
      sessionStorage.removeItem("ieee_reset_email");
      sessionStorage.removeItem("ieee_reset_phone");
      setMessage("Password updated successfully. Redirecting to login...");
      setTimeout(() => navigate("/"), 1000);
    } catch (err) {
      setError(getApiErrorMessage(err, "Unable to reset password"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Don't forget it this time"
      subtitle="You can create a new password now, make sure you don't forget it again."
    >
      <div className="text-center mb-4">
        <h2 className="fw-bold h3">Reset Password</h2>
        <p className="text-muted small">You can create a new password now</p>
      </div>

      <form onSubmit={handleReset}>
        <div className="mb-3">
          <label className="form-label label-custom">Password</label>
          <input
            type="password"
            className="form-control custom-input placeholdercolor"
            placeholder="Enter Your Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label className="form-label label-custom">Confirm Password</label>
          <input
            type="password"
            className="form-control custom-input placeholdercolor"
            placeholder="Re-Enter Your Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        {error ? <div className="alert alert-danger py-2 small">{error}</div> : null}
        {message ? <div className="alert alert-success py-2 small">{message}</div> : null}
        <button disabled={loading} type="submit" className="btn btn-primary-custom w-100 py-2 fw-bold mb-4 text-white">
          {loading ? "Updating..." : "Confirm"}
        </button>
      </form>

      <p className="text-center small">
        Go back to <Link to="/" className="fw-bold text-decoration-none text-primary">Log in</Link>
      </p>
    </AuthLayout>
  );
};

export default ResetPassword;
